import React from 'react';
import ProgressBar from './ProgressBar';

const PageLayout = ({ children, step, centered }) => {
  return (
    <div className={`page${centered ? ' page--centered' : ''}`}>
      {step !== undefined && <ProgressBar currentStep={step} />}
      <div className="container">
        {children}
      </div>
    </div>
  );
};

export default PageLayout;
